import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortal } from 'context';

const ScheduleButton = () => {
    const navigate = useNavigate();

    const {
        user: { username, partnerAccent },
    } = usePortal();

    return (
        <section className="subheader-item">
            <button className="subheader-button" onClick={() => navigate(`/${username}/schedule`)}>
                <h2 style={{ color: partnerAccent ? partnerAccent : undefined }}>{'Schedule'}</h2>
            </button>
        </section>
    );
};

export default ScheduleButton;
